import handler from 'api/handler'

const prefix = '/public/qualification'

const methods = {
  getQualifications: args => handler({ method: 'get', url: `${prefix}/qualifications`, params: args }),
  seedQualifications: args => handler({ method: 'post', url: `${prefix}/seed`, args }),
}

export default methods
